import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useLanding } from '@/components/Landing/LandingKit';
import { EditorialLink } from '@/components/Landing/LandingValueStory';
import { MONO } from '@/components/Landing/landingTokens';
import { CODING_TIERS } from '@/constants/apiContent';
import { ApiBody, ApiSection, ApiSplit, ApiTitle } from './ApiEditorial';

function ApiAuto() {
  const { c, band, isCompact } = useLanding();
  return (
    <ApiSection label="Automatic model routing" background={band.bg}>
      <ApiSplit>
        <View style={{ flex: isCompact ? undefined : 0.9, minWidth: 0 }}>
          <ApiTitle>Choose a model. Or let Auto choose.</ApiTitle>
          <ApiBody style={{ marginTop: 20 }}>Set model="auto" to route by the kind of work you’re doing. For coding tasks, the router also considers complexity.</ApiBody>
          <EditorialLink href="/docs/api" style={{ marginTop: 14 }}>Read about routing</EditorialLink>
        </View>
        <View style={{ flex: isCompact ? undefined : 1.5, minWidth: 0 }}>
          {CODING_TIERS.map((item, index) => (
            <View key={item.tier} style={{ paddingTop: index ? 20 : 0, paddingBottom: 20, borderBottomWidth: 1, borderBottomColor: c.rule }}>
              <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 18, lineHeight: 25, textTransform: 'capitalize' }}>{item.tier}</Text>
              <ApiBody style={{ fontSize: 15, lineHeight: 24, marginTop: 6 }}>{item.rule}.</ApiBody>
            </View>
          ))}
          <ApiBody style={{ fontSize: 15, lineHeight: 25, marginTop: 22 }}>For supported coding agents, the selected model stays consistent through a tool loop. A new user task can be routed again. Usage is billed for the model that runs.</ApiBody>
          <Text style={{ color: c.muted, fontSize: 13, lineHeight: 22, marginTop: 14 }}>Inspect the selected model in the response and routing headers, including <Text style={{ fontFamily: MONO, fontSize: 12 }}>X-Gab-Routed-Model</Text>.</Text>
        </View>
      </ApiSplit>
    </ApiSection>
  );
}
export default React.memo(ApiAuto);
